import { ChangeDetectorRef, Component, Input } from '@angular/core';

import { EMBED_TYPE_IMAGE_CONTENTS } from 'Angular/constants/core.constants';
import { PARTNER_OPTION_DEFAULT } from 'ChartApp/ts/apps/scatter-plot/constants';
import { SCATTER_PLOT_STATE_KEYS } from 'ChartApp/ts/apps/scatter-plot/state/constants';
import { TECH_CHART_STATE_KEYS } from 'ChartApp/ts/features/tech-chart/constants';
import { SavedItemType } from 'Angular/features/components/saved-items/enums/saved-item-type.enum';
import { ScatterPlotDataParams } from 'ChartApp/ts/types/scatter-plot-service-params.type';
import { TechChartFlatAppState } from 'ChartApp/ts/types/tech-chart-common.type';
import { FormattedShareableItem } from 'Angular/features/components/saved-items/open-item-modal/interfaces/serialized-shareable-item.interface';
import { FundChartState } from 'ChartApp/ts/interfaces/fund-chart.interface';

import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import { ScatterPlotService } from 'ChartApp/ts/services/scatter-plot.service';
import { TechChartAjaxService } from 'ChartApp/ts/services/tech-chart-ajax.service';

import { formFlattenedObject } from 'Angular/utils/urls';

/**
 * Open Item Preview Modal Component
 *
 * this modal is used for previewing the chart generator image for fund charts, scatter plots and tech charts
 *
 * Input Properties:
 *  savedItemType: string to determine how the imageUrl will be set
 */
@Component({
    standalone: false,
    selector: 'ycn-open-item-preview-modal',
    templateUrl: './open-item-preview-modal.template.html',
})
export class OpenItemPreviewModalComponent {
    @Input() savedItemType!: string;

    chartEmbedUrl: string = '';

    header: string = '';

    loading: boolean = true;

    modalOpen: boolean = false;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private fundChartService: FundChartService,
        private scatterPlotService: ScatterPlotService,
        private techChartService: TechChartAjaxService
    ) {}

    closeModal(): void {
        this.chartEmbedUrl = '';
        this.modalOpen = false;
    }

    openModal(item: FormattedShareableItem): void {
        this.loading = true;
        this.setChartEmbedUrl(item);
        this.header = `Preview ${item.name}`;
        this.modalOpen = true;

        this.changeDetectorRef.detectChanges();
    }

    setChartEmbedUrl(item: FormattedShareableItem): void {
        let previewState;

        switch (this.savedItemType) {
            case SavedItemType.FUND_CHART:
                previewState = {
                    ...item.state,
                    legendOnChart: true,
                    chartId: item.id,
                    partner: PARTNER_OPTION_DEFAULT,
                } as FundChartState;
                this.chartEmbedUrl = this.fundChartService.getChartEmbedUrl(previewState, EMBED_TYPE_IMAGE_CONTENTS);
                break;
            case SavedItemType.SCATTER_PLOT:
                previewState = {
                    ...formFlattenedObject(item.state, SCATTER_PLOT_STATE_KEYS),
                    chartId: item.id,
                    legendOnChart: true,
                    partner: PARTNER_OPTION_DEFAULT,
                    mode: EMBED_TYPE_IMAGE_CONTENTS,
                } as ScatterPlotDataParams;
                this.chartEmbedUrl = this.scatterPlotService.getChartEmbedUrl(previewState);
                break;
            case SavedItemType.TECH_CHART:
                previewState = {
                    ...formFlattenedObject(item.state, TECH_CHART_STATE_KEYS),
                    chartId: item.id,
                    legendOnChart: true,
                    partner: PARTNER_OPTION_DEFAULT,
                } as TechChartFlatAppState;
                this.chartEmbedUrl = this.techChartService.getChartEmbedUrl(previewState, EMBED_TYPE_IMAGE_CONTENTS);
                break;
            default:
        }
    }

    hideLoadingSymbol(): void {
        this.loading = false;
    }
}
